import { Tabs } from "antd";
import type { TabsProps } from "antd";

import VisitOne from "./VisitTabs/VisitOne";
import VisitTwo from "./VisitTabs/VisitTwo";
import VisitThree from "./VisitTabs/VisitThree";

const visitActiveImg = "/images/work-orders/visit_active.svg";
const visitInActiveImg = "/images/work-orders/visit_inactive.svg";
const visitNoDataImg = "/images/work-orders/visit_no_data.svg";

export default function WorkReports() {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: <img src={visitActiveImg} alt="Visit 1" />,
      children: <VisitOne />,
    },
    {
      key: "2",
      label: <img src={visitNoDataImg} alt="Visit 2" />,
      children: <VisitTwo />,
    },
    {
      key: "3",
      label: <img src={visitInActiveImg} alt="Visit 3" />,
      children: <VisitThree />,
    },
  ];

  return (
    <div className="visitTabs">
      <Tabs
        defaultActiveKey="1"
        items={items}
        tabPosition="left"
        className="workOrderDetailsTabs"
      />
    </div>
  );
}
